export function dasherize(target: string): string {
  // prettier-ignore
  return target
      .replace(/([A-Z])/g, (_match, p1: string) => `-${p1.toLowerCase()}`)
      .replace(/\s/g, '-')
}
